import React, { ReactElement } from 'react';
import { Label, Select } from 'idsk-react-components';
import ClassType from '../../../model/pripomienka/ClassType';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';
import SavePripomienka from '../../../model/pripomienka/SavePripomienka';

interface Props {
  classType: ClassType;
  updateField: SafeParameterSetter<SavePripomienka>;
  isZasadna?: boolean;
  width?: 'full' | 'three-quarters' | 'two-thirds' | 'one-half' | 'one-third' | 'one-quarter';
  error?: string;
}

const ZasadnaFormComponent = ({
  classType,
  updateField,
  isZasadna,
  error,
  width = 'one-half',
}: Props): ReactElement => classType === ClassType.PRIPOMIENKA
  && (
    <>
      <Label htmlFor="zasadna">Zásadná</Label>
      <Select
        id="zasadna"
        width={width}
        onChange={({ target }) => updateField('zasadna', target.value === 'true')}
        value={isZasadna ?? ''}
        error={error}
      >
        <option value="false">Nie</option>
        <option value="true">Áno</option>
      </Select>
    </>
  );

export default ZasadnaFormComponent;
